import React from "react";
import { Helmet } from "react-helmet";

import {
  Navbar,
  Footer,
  Landing,
  About,
  Skills,
  Testimonials,
  Blog,
  // Education, // Hidden — uncomment import and <Education /> below to restore section
  Experience,
  Contacts,
  Projects,
  Services,
  Achievement,
} from "../../components";
import { headerData } from "../../data/headerData";

function Main() {
  return (
    <div>
      <Helmet>
        <title>{headerData.name} — Portfolio</title>
      </Helmet>

      <Navbar />
      <Landing />
      <About />
      <Experience />
      <Skills />

      {/* <Education /> */}
      <Projects />
      <Achievement />
      <Contacts />
      <Footer />
    </div>
  );
}

export default Main;
